import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { GlobalService } from '@app/services/global.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-update-software-button',
  template: `
    @if (dockerEngineApiEnabled$ | async) {
      <a
        href="{{ updateServiceUrl }}"
        class="btn btn-outline-info"
        ngbTooltip="Open the Update Service page, select and install a desired OBLAC Drives release."
        placement="auto"
        container="body"
      >
        UPDATE SOFTWARE
      </a>
    }
  `,
  imports: [NgbTooltip, AsyncPipe],
})
export class UpdateSoftwareButtonComponent {
  private globalService = inject(GlobalService);

  dockerEngineApiEnabled$ = this.globalService.dockerEngineApiEnabled$;

  get updateServiceUrl() {
    return `${window.location.protocol}//${window.location.hostname}:${environment.updateServicePort}`;
  }
}
